module.exports = __webpack_public_path__ + "img/acs.5b3dd495.svg";